import { FC } from "react";
import { Button, HoursHeader, Time } from "./style";
import { ChevronRightIcon } from "shared/ui/icons";
import { ScheduleRow } from "entities/weather/model/types";
import { ChevronLeftIcon } from "shared/ui/icons/chevronLeftIcon";

type WeatherHoursProps = {
  hours: ScheduleRow["hours"];
  showPrev?: boolean;
  showNext?: boolean;
  handlePrev: () => void;
  handleNext: () => void;
};

export const WeatherHours: FC<WeatherHoursProps> = ({
  hours,
  showPrev,
  showNext,
  handleNext,
  handlePrev,
}) => {
  return (
    <HoursHeader>
      {showPrev && (
        <Button
          style={{
            position: "absolute",
            top: 5,
          }}
          onClick={() => handlePrev()}
        >
          <ChevronLeftIcon /> До
        </Button>
      )}
      {hours.map((h) => (
        <Time key={h.label}>{h.label}</Time>
      ))}
      {showNext && (
        <Button
          style={{
            position: "absolute",
            right: 16,
          }}
          onClick={() => handleNext()}
        >
          После <ChevronRightIcon />
        </Button>
      )}
    </HoursHeader>
  );
};
